import React, { useEffect, useState, useContext } from 'react'
import MenuAdmin from '../navAdmin/Menu'
import Footer from '../../footer/Footer'
import Information from '../../public/Information/Information';
import { CurrentUserContext } from '../../../App';
import PharmacogeneticTest from '../../public/Information/PharmacogeneticTest';


function InformationPharmacogenetic ()  {
    return(
        <>
            <MenuAdmin menuActive={'mangePetition'} />
            <PharmacogeneticTest />
            <Footer />
        </>
    )
}

export default InformationPharmacogenetic